import React, { MouseEvent, useCallback } from "react";
import { logout } from "../auth/authApi.js";
import { useAuth } from "../auth/AuthProvider.js";
import { useHref } from "../../../packages/router/href/HrefProvider.js";

/**
 * Renders the application logout link.
 */
export const LogoutLink = () => {
  const { setHref } = useHref();

  const { setLoggedIn } = useAuth();

  const handleLogout = useCallback(
    async (event: MouseEvent) => {
      event.preventDefault();
      await logout();
      setLoggedIn(false);
      setHref("/login");
    },
    [setHref, setLoggedIn]
  );

  return (
    <a href="#" onClick={handleLogout}>
      Logi välja
    </a>
  );
};
